import { FORM_MESSAGE } from '@/constants/form.constants';
import type {
  CMSInputTextAreaField,
  CMSInputTextField,
  CMSSelectField,
} from '@/services/cms/getCMSForm/schema';
import { z } from 'zod';

// NOTE: we only have 3 validation rules: email, required, sometimes.
export const generateTextValidationRules = (form: CMSInputTextField) => {
  const validate = form.validate;

  // with email path
  if (validate.includes('email')) {
    if (validate.includes('required')) {
      return z.string().email(FORM_MESSAGE.INVALID_EMAIL_ADDRESS);
    }

    // NOTE: we have to do this to only validate email if there's value when field is optional
    if (validate.includes('sometimes')) {
      return z
        .string()
        .email(FORM_MESSAGE.INVALID_EMAIL_ADDRESS)
        .or(z.literal(''));
    }
  }

  // non email path
  let baseValidator = z.string();
  if (validate.includes('required')) {
    baseValidator = baseValidator.min(1, FORM_MESSAGE.REQUIRED(form.display));
  }
  return baseValidator;
};

// NOTE: we can combine these two functions into one if they don't have differences.
export const generateTextAreaValidationRules = (
  form: CMSInputTextAreaField
) => {
  let baseValidator = z.string();
  const validate = form.validate;

  if (validate.includes('required')) {
    baseValidator = baseValidator.min(1, FORM_MESSAGE.REQUIRED(form.display));
  }
  return baseValidator;
};

export const generateSelectValidationRules = (form: CMSSelectField) => {
  let baseValidator = z.string();
  const validate = form.validate;

  if (validate.includes('required')) {
    baseValidator = baseValidator.min(1, FORM_MESSAGE.REQUIRED(form.display));
  }
  return baseValidator;
};
